// ============================================================================
// HOPCROFT-KARP - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'hopcroft-karp',
  name: 'Hopcroft-Karp',
  category: 'Graphs',
  complexity: {
    time: 'O(E√V)',
    space: 'O(V)'
  },
  description: 'An algorithm for finding maximum matching in bipartite graphs. It improves upon the simple augmenting path algorithm by finding multiple augmenting paths in each phase using BFS layering and DFS.'
};
